module.exports = __webpack_public_path__ + "static/john-ocean-square.865ddbdf.jpg";